import * as GetProjectCapTableTypes from 'src/actions/project/cap-table/Types';
import {
  GetProjectCapTableAction,
  GetProjectCapTableSuccess
} from 'src/actions/project/cap-table/GetProjectCapTable.actions';
import CapTable from 'src/value-objects/CapTable';

export interface GetProjectCapTableState {
  projectCapTable?: CapTable;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetProjectCapTableState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetProjectCapTableReducer(
  state: GetProjectCapTableState = initialState,
  action: GetProjectCapTableAction
): GetProjectCapTableState {

  switch (action.type) {
    case GetProjectCapTableTypes.GET_PROJECT_CAP_TABLE_ATTEMPT:
      return {...state, projectCapTable: undefined, loading: true, error: false};
    case GetProjectCapTableTypes.GET_PROJECT_CAP_TABLE_SUCCESS:
      const projectCapTable: CapTable = (action as GetProjectCapTableSuccess).payload;
      return {...state, projectCapTable: projectCapTable, loading: false, error: false};
    case GetProjectCapTableTypes.GET_PROJECT_CAP_TABLE_FAILURE:
      return {...state, projectCapTable: undefined, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/cap-table/GetProjectCapTableReducer.tsx